module.exports = __webpack_public_path__ + "static/media/InteractivePortfolioScreenShot.3c6bfdc4.JPG";